<template>
  <ActionButton
    class="order-action-button"
    mode="secondary"
    :actions="availableActions"
    :loading="loading"
  />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { ActionCommand } from '@rygen/rygen-ui/model';
import { Order as EsOrder } from '@rygen/tms-search-model/search/order';

import { useOrderBatchAction } from '@/composables';
import { OrderAction, OrderSearchData } from '@/model';

import ActionButton from '@rygen/rygen-ui/components/button/ActionButton.vue';

const props = defineProps({
  selectedData: {
    type: Array as PropType<OrderSearchData[] | EsOrder[]>,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
const { selectedData, loading } = toRefs(props);
const emit = defineEmits<{
  (event: 'command', payload: ActionCommand<OrderAction>): void;
}>();

const { availableActions } = useOrderBatchAction(
  selectedData,
  (command: ActionCommand<OrderAction>) => emit('command', command),
);
</script>
